import GroupLayer from '@arcgis/core/layers/GroupLayer';

/**
 * A pre-constructed ArcGIS GroupLayer for grouping property pin graphics on the map, identified by the id 'operation-prop-pins'.
 */
export const propertyPinGroupLayer = new GroupLayer({ id: 'operation-prop-pins', title:'Property Pins' });

/**
 * A pre-constructed ArcGIS GroupLayer for grouping potential acquisition pin graphics on the map, identified by the id 'potential-prop-pins'.
 */
export const potentialAcquisitionPinGroupLayer = new GroupLayer({ id: 'potential-prop-pins', title:'Potential Acquisition Pins' });

/** ID string for the division potential pins Layer (used in maps). */
export const acquisitionPinLayerId = `division-potential-pins`;

/** ID string for the acquisition boundary Layer (used in maps). */
export const acquisitionLayerId = 'acquisitionBoundaryLayer';

/** ID string for the acquisition group Layer (used in maps). */
export const acquisitionGroupLayerId = 'acquisition-group-layer';

/** A pre-constructed ArcGIS GroupLayer for the acquisition group layer, identified by `acquisitionGroupLayerId`. */
export const acquisitionGroupLayerMini = new GroupLayer({ id: acquisitionGroupLayerId });

/**
 * A pre-constructed ArcGIS GroupLayer for potential acquisition-related layers on the map, titled 'Potential Acquisition Layers'.
 */
export const acquisitionGroupLayer = new GroupLayer({title:'Potential Acquisition Layers',});

/**
 * A pre-constructed ArcGIS GroupLayer for grouping property boundary layers on the map, titled 'Property Boundaries'.
 */
export const propertyBoundariesGroupLayer = new GroupLayer({
  title: 'Property Boundaries',
});

